import React from 'react';
import styles from './Footer.module.css';

const footerLinks = {
  Product: [
    { name: 'Docs', url: '#docs' },
    { name: 'GitHub', url: '#github' }
  ],
  Community: [
    { name: 'Discord', url: '#discord' },
    { name: 'Twitter', url: '#twitter' }
  ],
  Solana: [
    { name: 'Solana.com', url: 'https://solana.com' },
    { name: 'Anchor', url: '#anchor' },
    { name: 'SPL Docs', url: '#spl' }
  ]
};

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.content}>
          <div className={styles.brand}>
            <h3>SOLAR</h3>
            <p>Building the future of gambling on Solana</p>
          </div>
          
          <div className={styles.links}>
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category} className={styles.linkGroup}>
                <h4>{category}</h4>
                <ul>
                  {links.map((link, index) => (
                    <li key={index}>
                      <a href={link.url}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        
        <div className={styles.bottom}>
          <p>&copy; {new Date().getFullYear()} Solar. All rights reserved.</p>
          <div className={styles.legal}>
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 